import { Box, DataList, Flex, Text, Tooltip } from '@radix-ui/themes'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { GiModernCity } from 'react-icons/gi'
import { RxBackpack, RxMobile, RxPerson } from 'react-icons/rx'
import { TbRoad } from 'react-icons/tb'
import { type GetAddress } from '~/models/ecommerce-providers/sylius/shop/fetch/address/get-address.ts'
import { PROFILE_ADDRESSES_INDEX_I18NEXT } from '~/routes/($lang).profile.addresses._index/index.component.tsx'

/* -------------------------------------------------------------------------------------------------
 * AddressTooltip
 * -----------------------------------------------------------------------------------------------*/

type AddressListProps = {
	address: GetAddress
}

const AddressList: React.FC<AddressListProps> = ({ address }) => {
	const { t } = useTranslation(
		PROFILE_ADDRESSES_INDEX_I18NEXT.routeProfileAddressesIndex,
	)

	return (
		<DataList.Root>
			{[
				{ props: ['firstName', 'lastName'], Icon: RxPerson },
				{ props: ['street'], Icon: TbRoad },
				{ props: ['countryCode', 'postcode', 'city'], Icon: GiModernCity },
				{ props: ['company'], Icon: RxBackpack },
				{ props: ['phoneNumber'], Icon: RxMobile },
			].map(
				({ props, Icon }) =>
					props.find(
						(prop: string) =>
							// @ts-ignore
							address[prop],
					) && (
						<DataList.Item key={props[0]} align="center">
							<DataList.Label minWidth="10px">
								<Tooltip
									content={
										<Flex align="center" gapX="2">
											{props.map((prop) => (
												<Text key={prop} color="gray">
													{t(`label.${prop}`)}
												</Text>
											))}
										</Flex>
									}
								>
									<Box>
										<Icon size="1.2em" />
									</Box>
								</Tooltip>
							</DataList.Label>
							<DataList.Value>
								<Flex display="inline-flex" align="center" gapX="1">
									{props.map((prop) => (
										<Text key={prop}>
											{
												// @ts-ignore
												address[prop]
											}
										</Text>
									))}
								</Flex>
							</DataList.Value>
						</DataList.Item>
					),
			)}
		</DataList.Root>
	)
}

/* -----------------------------------------------------------------------------------------------*/

export { AddressList }
